// --- INJECTED ---
import { getI18n } from '@/core/i18n';

const i18n = getI18n();
// --- /INJECTED ---

const breadCrumb = [
  {
    label: i18n.t('misc.telemetry'),
    route: { name: 'telemetry$telemetry' },
  },
  {
    label: '',
    route: { name: 'telemetry$detail' }, // 1
  },
  {
    label: i18n.t('misc.telemetry_settings'),
    route: { name: 'telemetry$settings' }, // 2
  },
];

export default [
  {
    path: '/telemetry',
    name: 'telemetry$telemetry',
    component: () => import('@/apps/telemetry/views/Telemetry'),
    meta: {
      breadCrumb: [breadCrumb[0]],
      title: i18n.t('misc.telemetry'),
    },
  },
  {
    path: '/telemetry/:id',
    name: 'telemetry$detail',
    component: () => import('@/apps/telemetry/views/Detail/Detail'),
    meta: {
      breadCrumb: [breadCrumb[0], breadCrumb[1]],
      title: i18n.t('misc.telemetry_page'),
    },
  },
  {
    path: '/telemetry/:id/settings',
    name: 'telemetry$settings',
    component: () => import('@/apps/telemetry/views/Settings/Settings'),
    meta: {
      breadCrumb: [breadCrumb[0], breadCrumb[1], breadCrumb[2]],
      title: i18n.t('misc.telemetry_settings'),
    },
  },
];
